<!--
param-link

Gets params from the URL and adds them to the link
-->
<template>
	<a :href="addParams(url)">
		<template v-if="label">
			{{ label }}
		</template>
		<slot v-else-if="this.$slots.content" name="content"></slot>
		<slot v-else></slot>
	</a>
</template>

<script>
	export default {
		name: "param-link",

		props: {
			url: {
				type: String,
			},
			label: {
				type: String,
			},
			params: {
				type: Array,
				default: ['promo'],
			}
		},

		methods: {
			addParams(url) {
				const queryString = window.location.search;
				const urlParams = new URLSearchParams(queryString);
				let newUrl = new URL(url);

				for (const item of this.params) {
					const param = urlParams.get(item);

					if(param) {
						newUrl.searchParams.set(item, param);
					}
				}

				return newUrl;
			},
		},
	};
</script>
